import { IUser } from 'src/app/model/service/iuser';

function extractPayload(token: string): any {
    return token ? JSON.parse(atob(token.split('.')[1])) : null;
}

export function millisRemaining(token: string): number {
    const payload = extractPayload(token);
    const exp = payload ? payload.exp : 0;
    return new Date(exp * 1000).getTime() - Date.now();
}

export function validate(token: string): boolean {
    return millisRemaining(token) > 0;
}

export function extractApplicant(token: string): IUser {
    const payload = extractPayload(token);
    return payload ? {
        email: payload.sub,
        name: `${payload.given_name ? payload.given_name : ''} ${payload.family_name ? payload.family_name : ''}`.trim(),
        ssn: payload.sub,
    } : null;
}

export function extractAdUser(token: string): string {
    const payload = extractPayload(token);
    return payload ? payload.sub : null;
}
